// extracted by mini-css-extract-plugin
export default {"container":"USForbidden_container__RBVwt","v1":"USForbidden_v1__+p5GK"};